var $e73bf42412feb220$exports = {};
const $e73bf42412feb220$var$countdown = ()=>{
    setTimeout($e73bf42412feb220$var$redirect, 5000);
};
const $e73bf42412feb220$var$redirect = ()=>{
    const url = document.documentElement.dataset.url;
    document.location.href = url;
};
$e73bf42412feb220$var$countdown();


//# sourceMappingURL=ajkoffshore.com.e71f3479.js.map
